// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0badd36c","453":"ee051c4c","455":"20afd6b4","977":"b7866d5a"}[chunkId] + ".chunk.js";
};